import dayjs from 'dayjs';

const getExpired = (expiration: string | null | undefined) =>
	expiration && dayjs(expiration).isBefore(dayjs(), 'day');

const getExpiringSoon = (expiration: string | null | undefined) =>
	expiration && dayjs(expiration).isBefore(dayjs().add(1, 'month'), 'day');

export interface GetExpirationStatusParams {
	expiration: string | null | undefined;
	autorenew: boolean;
}

const getExpirationStatus = ({
	expiration,
	autorenew,
}: GetExpirationStatusParams) => {
	if (!expiration) {
		return null;
	}

	if (getExpired(expiration)) {
		return 'expired';
	}

	if (!autorenew && getExpiringSoon(expiration)) {
		return 'expiringSoon';
	}

	return 'current';
};

export default getExpirationStatus;
